import { render } from "./FormLabel.vue?vue&type=template&id=317ab5db&ts=true"
import script from "./FormLabel.vue?vue&type=script&lang=ts&setup=true"
export * from "./FormLabel.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/form/FormLabel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "317ab5db"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('317ab5db', __exports__)) {
    api.reload('317ab5db', __exports__)
  }
  
  module.hot.accept("./FormLabel.vue?vue&type=template&id=317ab5db&ts=true", () => {
    api.rerender('317ab5db', render)
  })

}


export default __exports__